import { SxProps, Theme, styled } from "@mui/material/styles";
import type { FC } from "react";

interface LogoProps {
  sx?: SxProps<Theme>;
}

const LogoRoot = styled("img")({});

const Logo: FC<LogoProps> = (props) => (
  <LogoRoot
    src="/logo-ebinex.svg"
    width="100"
    height="25"
    loading="eager"
    alt="Ebinex logo"
    decoding="async"
    {...props}
  />
);

export default Logo;
